import React, { Component } from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import DRNButton from '../../standard/Button/DRNButton';
import DRNImage from '../../standard/Image/DRNImage';
import DRNInputField from '../../standard/InputField';
import { DRNUtil } from '@traveloka/district-util';
import { withTheme } from '../../theme';
class Stepper extends Component {
    constructor(props) {
        super(props);
        this.handleMinusButtonPressIn = () => {
            this.setState((prevState, props) => ({
                value: prevState.value - 1 < props.minValue ? props.minValue : prevState.value - 1,
            }), () => {
                this.props.onChange(this.state.value);
            });
        };
        this.handlePlusButtonPressIn = () => {
            this.setState((prevState, props) => ({
                value: prevState.value + 1 > props.maxValue ? props.maxValue : prevState.value + 1,
            }), () => {
                this.props.onChange(this.state.value);
            });
        };
        this.handleInputFieldChange = newTextValue => {
            const { minValue, maxValue } = this.props;
            // Check whether input is valid using regular expression (positive number only)
            if (/^\d+$/.test(newTextValue)) {
                let newIntegerValue = parseInt(newTextValue);
                // Check whether newIntegerValue overflows
                if (newIntegerValue < minValue) {
                    newIntegerValue = minValue;
                }
                if (newIntegerValue > maxValue) {
                    newIntegerValue = maxValue;
                }
                this.setState({ value: newIntegerValue }, () => {
                    this.props.onChange(this.state.value);
                });
            }
        };
        this.minTextInputContainerWidth = 48;
        this.state = {
            value: props.value,
            textInputContainerWidth: this.minTextInputContainerWidth,
        };
    }
    render() {
        const { minValue, maxValue, minusButtonStyle, plusButtonStyle, variant, theme } = this.props;
        const { value, textInputContainerWidth } = this.state;
        const buttonVariant = variant === DRNInputField.VARIANT_STANDARD ? DRNButton.VARIANT.SECONDARY : DRNButton.VARIANT.TEXT;
        const marginHorizontalField = variant === DRNInputField.VARIANT_STANDARD ? R.spacing.xxs : R.spacing.xs;
        return (<View style={styles.stepperContainer}>
        <DRNButton.Icon variant={buttonVariant} buttonStyle={minusButtonStyle ? minusButtonStyle : null} disabled={value <= minValue} Icon={() => (<DRNImage style={{ height: 16, width: 16, marginVertical: R.spacing.xxs, tintColor: theme.tintPrimary }} source={require('../../../images/ic_sys_add-minus.png')}/>)} onPress={this.handleMinusButtonPressIn}/>
        <View style={{ width: textInputContainerWidth, marginHorizontal: marginHorizontalField }}>
          <DRNInputField variant={variant} textAlign={'center'} clearButtonMode={'never'} keyboardType={Platform.OS === 'android' ? 'numeric' : 'number-pad'} onChangeText={this.handleInputFieldChange} value={String(value)} style={
        // This fixes layout issue on Firefox https://tvlk.slack.com/archives/G08DKB77C/p1578307139014400
        DRNUtil.isWeb()
            ? {
                minWidth: 0,
                '-moz-appearance': 'textfield',
            }
            : undefined}/>
        </View>
        <DRNButton.Icon variant={buttonVariant} buttonStyle={plusButtonStyle ? plusButtonStyle : null} disabled={value >= maxValue} Icon={() => (<DRNImage style={{ height: 16, width: 16, marginVertical: R.spacing.xxs, tintColor: theme.tintPrimary }} source={require('../../../images/ic_sys_add-plus.png')}/>)} onPress={this.handlePlusButtonPressIn}/>
      </View>);
    }
}
Stepper.propTypes = {
    value: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    onChange: PropTypes.func,
    minusButtonStyle: PropTypes.shape({}),
    plusButtonStyle: PropTypes.shape({}),
    variant: PropTypes.oneOf([DRNInputField.VARIANT_STANDARD, DRNInputField.VARIANT_MINIMAL]),
};
Stepper.defaultProps = {
    value: 0,
    minValue: 0,
    maxValue: 999,
    onChange: () => { },
    variant: DRNInputField.VARIANT_STANDARD,
};
const styles = StyleSheet.create({
    stepperContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default withTheme(Stepper);
